export default "__VITE_ASSET__2cf703b3__"